import { getUpmCategoryIds } from 'Pages/help/constants';
import { ACTUserPointsResponse } from 'Shared/models/swagger/act';
import { UPMCategory } from 'Shared/models/swagger/upm';
import { getUserCacheData, UserSessionCacheKeys } from 'Shared/services/sessionCacheService';
import { useGetCategoryData } from 'Shared/services/userActivation/app/questionService';

/**
 * Custom hook to get GP has ever completed status
 * @param isLoggedIn
 * @returns boolean
 */
export const useGpHasEverCompleted = (isLoggedIn = true) => {
  const gpCategoryId     = getUpmCategoryIds().GENERAL_PROFILE;
  let   hasEverCompleted = false;

  const cachedGPData: UPMCategory | undefined = getUserCacheData(UserSessionCacheKeys.CATEGORY_DATA, gpCategoryId);
  if (cachedGPData?.hasEverCompleted) {
    hasEverCompleted = true;
  }

  const cachedPoints: ACTUserPointsResponse | undefined = getUserCacheData(UserSessionCacheKeys.USER_POINTS);
  if (cachedPoints?.lifetimePoints && cachedPoints?.lifetimePoints >= 100) {
    hasEverCompleted = true;
  }

  const { data: categoryData } = useGetCategoryData(isLoggedIn ? gpCategoryId : null);
  if (!!categoryData?.hasEverCompleted) {
    hasEverCompleted = true;
  }

  return hasEverCompleted;
};

export default useGpHasEverCompleted;